<template>
    <div class="transfer-page" :class="theme">
        <div class="transfer-container ff-text flex flex-col w-full" :class="stage">
            <TopBar :theme="theme" :stage="stage" :lbl="lbl" @clickBack="clickTopBarBack()"></TopBar>

            <template v-if="isPageReady">
                <ConvertHeader ref="convertHeader" v-bind="headerConfig" :blobConfig="landingFlow.states.appConfig"
                    :fromApp="fromApp" :toApp="toApp" :stage="stage" :lbl="lbl" @onTranExpire="onTranExpire">
                </ConvertHeader>

                <template v-if="stage == 'init'">
                    <WalletAddress ref="walletAddr" :lbl="lbl" @onContinue="onContinue" :states="landingFlow.states"></WalletAddress>
                </template>
                <template v-else-if="stage == 'tier'">
                    <TransferTier ref="transferTier" :lbl="lbl" :objTier="pointTiersList" @onClickTier="onClickTier">
                    </TransferTier>
                </template>
                <template v-else>
                    <TransferResult :lbl="lbl" @onClickBack="clickBackCampaign"></TransferResult>
                </template>
                <div class="wrapper-logo-bzb">
                    <img class="logo-bzb mx-auto" src="../assets/buzzebees-logo.svg" />
                </div>
            </template>
        </div>
    </div>

    <ModalMaster :controller="modalController" />
</template>
<script>
import { computed, onMounted, provide } from "vue";
import { useRoute } from "vue-router";
import useModalStore from "../store/ModalStore"
import useLocaleStore from "../store/LocaleStore";
import useAccountStore from "../store/AccountStore"
import useModalSetup from "../composable/useModalSetup"
import LandingFlow from "../composable/LandingFlow";
import useBitkub from "../composable/useBitkub"
import useAlertModal from "../composable/useAlertModal";

// helper
import Util from "@/helper/Utility.js";
//component
import TopBar from "../component/TopBar/TopBar.vue";
import ConvertHeader from "../component/Header/ConvertHeader.vue";
import WalletAddress from "../component/Body/WalletAddress.vue";
import TransferResult from "../component/Result/TransferResult.vue";
import TransferTier from "../component/Tier/Tier.vue";

// service
import Service from "../service/TransferPointService.js";
import mongoService from "../../../service/mongoService";

//modal
import ModalMaster from "../component/Modal/ModalMaster.vue";

export default {
    name: "Bitkub",
    components: {
        TopBar,
        ConvertHeader,
        WalletAddress,
        TransferTier,
        // Convert,
        // Result,
        ModalMaster,
        TransferResult,
    },
    data: function () {
        return {
            stage: "init",
            theme: "template_apiservice",
            isLoadedCampaign: false,
            resultCheck: null
        };
    },
    provide: function () {
        return {
            lbl: this.lbl,
            getModalController: () => this.modalController,
            getQueryString: () => this.query,
            getWebLandingBlob: () => this.weblandingBlob,
            getPoints: () => this.points,
            getBlobConfig: () => this.blobConfig,
            getDeductPoints: () => this.deductPoints,
        };
    },
    computed: {
        fromApp: function () {
            return "";
        },
        toApp: function () {
            return this.lbl.exchangeName;
        },
        headerConfig: function () {
            if (this.stage == "init" || this.stage == "result") {
                return {
                    showResult: this.stage == "result" ? true : false,
                    mode: this.stage == "result" ? "name" : "",
                    showCurrentPoint: false,
                };
            } else {
                return {
                    mode: "",
                    showCurrentPoint: true,
                };
            }
        },
    },
    setup: function () {
        const ModalStore = useModalStore();
        const LocaleStore = useLocaleStore()
        const AccountStore = useAccountStore()
        const route = useRoute()

        // setup modal
        useModalSetup(ModalStore)

        const { showApiErrorModal } = useAlertModal(ModalStore)

        const landingFlow = LandingFlow({
            mainAppName: "bitkub"
        },
            AccountStore,
            LocaleStore
        )
        const bitkubStates = useBitkub(landingFlow.states)

        const pointTiersList = computed(() => {
            let json = {}

            if (landingFlow.states.campaign != null) {
                // parse from customFacebookMessage
                json = JSON.parse(landingFlow.states.campaign.customFacebookMessage)
                // console.log(json)
            } else {
                // for UI phase only
                json = {
                    point: [
                        // { Points: 10, Partner: 1000 },
                        // { Points: 20, Partner: 1000 },
                        // { Points: 1250, Partner: 1000 },
                        // { Points: 1250, Partner: 1000 },
                    ],
                }
            }

            return json
        })

        provide("ModalStore", ModalStore)
        provide("LocaleStore", LocaleStore)
        provide("AccountStore", AccountStore)
        provide("BitkubStates", bitkubStates)

        onMounted(() => {
            if (route.query?.locale != null) {
                LocaleStore.setters.setLocale(route.query?.locale);
            }
        })

        return {
            modalController: ModalStore.methods.getModalController(),
            landingFlow,
            lbl: LocaleStore.lbl,
            isPageReady: landingFlow.isPageReady,
            pointTiersList,
            showApiErrorModal,
            bitkubStates
        }
    },
    mounted: function () {
        this.init()
    },
    methods: {
        //#region init
        init: function () {
            // config landing flow
            this.landingFlow.events.onError = (err) => {
                console.log("init error", err)
                this.modalController.loadingModal.hide()
            }
            this.landingFlow.events.onReady = () => {
                // console.log("isPageReady", isPageReady)
                this.stage = "init"
                this.modalController.loadingModal.hide()
                this.bitkubStates.updatePoints(this.landingFlow.states.profile.profile)
            }

            // start initial
            this.modalController.loadingModal.show()
            this.landingFlow.init()
        },
        //#endregion init

        //#region utility
        afterClickOkGotoCampaign: function () {
            this.modalController.alertModal.onClickOk(() => {
                window.location.replace(this.query.returnUrl);
            });
        },
        //#endregion

        //#region api
        convertAPI: function (points) {
            return Service.convertPoint(
                this.landingFlow.states.mainAppName,
                this.landingFlow.states.query.token,
                this.landingFlow.transferPointStates.resultCheck.tranid,
                this.landingFlow.states.query.appName,
                this.landingFlow.states.query.apiPrefix,
                null, // ext params
                this.landingFlow.states.blobWebLanding,
                points, 
                this.landingFlow.states.query.jwt,
            );
        },
        callCheckAPI: async function () {
            // reset value
            this.deductPoints = 0
            try {
                this.modalController.loadingModal.show();
                // console.log("before")
                var res = await Service.postCheck(
                    this.landingFlow.states.mainAppName,
                    this.landingFlow.states.query.token,
                    this.bitkubStates.walletAddress.value,
                    this.landingFlow.states.query.apiPrefix,
                    this.landingFlow.states.blobWebLanding,
                    this.landingFlow.states.query.jwt
                );
                this.landingFlow.transferPointStates.resultCheck = res;
                // console.log(res)
                this.modalController.loadingModal.hide();
                // console.log("after")
                return true
            } catch (err) {
                console.log(err)
                this.modalController.loadingModal.hide();
                this.showApiErrorModal(this.lbl.errors.somethingWrong.title, err)
            }

            return false
        },
        callConvertAPI: async function (points) {
            // console.log(points)
            this.modalController.loadingModal.show()
            var theme = this.landingFlow.states.query.theme || "";
            var appName = this.landingFlow.states.query.appName || theme || ""; 
            var params = {
                tranid:  this.landingFlow.transferPointStates.resultCheck.tranid,
                points: points
            }
 
            try {
                var res = await this.convertAPI(points);
                this.bitkubStates.updatePoints(res.data)
                this.modalController.loadingModal.hide()
                // this.deductPoints = points
                mongoService.sendSuccessLogMongoDb(appName, theme, params, res);  
                return true
            } catch (err) {
                this.deductPoints = 0
                this.modalController.loadingModal.hide()
                this.showApiErrorModal(this.lbl.errors.somethingWrong.title, err)
                mongoService.sendErrorLogMongoDb(err.err, params, appName, theme); 
            }

            return false
        },
        //#endregion

        //#region ui flow
        clickTopBarBack: function () {
            if (this.stage == "tier") {
                // clear timer
                this.$refs.convertHeader.stopTimer();
                this.stage = "init";
            } else if (this.stage == "init") this.clickBackCampaign();
            else if (this.stage == "result") this.clickBackCampaign();
        },
        clickBackCampaign: function () {
            // console.log(this.query.returnUrl);
            // remove local storage
            localStorage.removeItem("bk.refreshToken")
            if (!Util.isEmptyStr(this.landingFlow.states.query.returnUrl)) {
                window.location.replace(this.landingFlow.states.query.returnUrl);
            }
        },
        //#endregion

        //#region events
        onContinue: function (walletAddress) {
            this.bitkubStates.walletAddress.value = walletAddress;
            // check code on server
            this.callCheckAPI().then((result) => {
                // console.log(result, this.pointTiersList)
                if (result) {
                    this.stage = "tier";
                    this.$refs.convertHeader.startTimer();

                    this.$nextTick(() => {
                        setTimeout(() => {
                            Util.scrollTop()
                        }, 100);
                    })
                }
            });

            // object { tranid, rate }
        },
        onClickTier: function (data) {
            // console.log(data);
            this.selectTier = data.tier
            // stop timer then show otp
            this.$refs.convertHeader.stopTimer();
            this.modalController.transferConfirmModal
                .clearModal()
                .setBlobConfig(this.landingFlow.states.appConfig)
                .setWalletAddress(this.bitkubStates.walletAddress.value)
                .setPoints(data.tier.Points, data.points)
                .show();
            this.modalController.transferConfirmModal.onClickOk(() => {
                // call redeem
                this.callConvertAPI(data.tier.Points).then((result) => {
                    if (result) {
                        // goto result page
                        this.stage = "result"
                    }
                })
            });
            this.modalController.transferConfirmModal.onHidden((result) => {
                // console.log(result);
                // request new trans id
                if (result.cancel) {
                    this.onTranExpire();
                }
            });
        },
        onTranExpire: function () {
            // check wallet address to get trans id
            this.callCheckAPI().then((result) => {
                if (result) {
                    // call update trans id
                    this.$refs.convertHeader.startTimer();
                }
            });
        },
        //#endregion
    },
};
</script>
<style lang="scss">
@import "../style/main.scss";
</style>
<style lang="scss" scoped>
@import "../style/base.scss";

.transfer-page {
    background-color: #f4f4f4;
    color: $gray;
    @extend %base-class;

    .transfer-container {
        position: relative;
        width: 100%;
        margin: 0 auto;
        padding-bottom: 40px;
        min-height: 100vh;
        background-color: $bg-gray;

        &.result {
            background-color: #fff;
        }

        @include max-mobile {
            padding-bottom: 40px;
        }

        @include tablet {
            padding-bottom: 100px;
        }

        @include min-desktop {
            padding-bottom: 100px;
            max-width: 1200px;
        }

        .wrapper-logo-bzb {
            position: absolute;
            left: 0px;
            bottom: 0px;
            width: 100%;
            text-align: center;
            padding: 15px 0 15px 0;
            background-color: #fff;

            @include max-mobile {
                padding: 15px 0 15px 0;
            }

            @include tablet {
                padding: 40px 0 40px 0;
            }

            @include min-desktop {
                padding: 40px 0 40px 0;
            }

            .logo-bzb {
                height: 20px;
            }
        }
    }
}
</style>

